import { render, staticRenderFns } from "./durationstatistics.vue?vue&type=template&id=403c1e17"
import script from "./durationstatistics.vue?vue&type=script&lang=js"
export * from "./durationstatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports